import styles from "./services-menu-item.module.css";

export const ServicesMenuItem = ({ title, img, onClick }) => {
    return <section className={styles.servicesMenuItem} onClick={onClick}>
        <img className={styles.img} src={`img${img}`} alt="" />
        <span className={styles.title}>{title}</span>
    </section>
}